import AudioRecordBar from './AudioRecordBar';
export default AudioRecordBar;
